import "./Main.css";
import Productc from "../../secondary/product/Productc.jsx";
import Card from "../../secondary/card/Card.jsx";
import { Swiper, SwiperSlide } from 'swiper/react';


function Main(){
  return(
    <main>
      <div className="content">
        <div className="mian-cont">
          <div>
            <Productc title="ერთი ნახვით საჩუქარი" countdown="1 დღე : 20 საათი : 59 წუთი">
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
            </Productc>
          </div>
          <div>
            <Productc title="ახალი მოდელები" countdown="0 დღე : 17 საათი : 59 წუთი">
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={13699}
                oldPrice={13799}
                monthPrice={380}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2Fe45fd6bc-ca61-4525-8594-14a1022f4434_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
            </Productc>
          </div>
          <div>
            <Productc title="ახალი მოდელები" countdown="0 დღე : 17 საათი : 59 წუთი">
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={13699}
                oldPrice={13799}
                monthPrice={380}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2Fe45fd6bc-ca61-4525-8594-14a1022f4434_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide >
                <Card 
                title={"Apple iPhone 15 | 128GB Black"}
                price={2340}
                monthPrice={39}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F5bbd3e79-6644-472a-8972-4d363ae358a5_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>

              <SwiperSlide >
                <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={3999}
                oldPrice={4399}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2F4fc617b5-768b-44ff-bcbc-0e4c07ac0cd7_Thumb.jpeg&w=256&q=50"} />
              </SwiperSlide>
            </Productc>
            <div>
            <Productc title="ლეპტოპები">
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2Ffa42c460-93b0-47b1-84dd-5da038a31c118ca3d25c-8067-4b3f-8d19-6f398c1740fe.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0194784_lenovo-ideapad-slim-3-82x80025rk-intel-core-i5-1335u-intel-iris-xe-graphics-16gb-ram-ssd-512gb-free-_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0195816_asus-vivobook-16-m3604ya-mb106-black_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2Ffa42c460-93b0-47b1-84dd-5da038a31c118ca3d25c-8067-4b3f-8d19-6f398c1740fe.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0194784_lenovo-ideapad-slim-3-82x80025rk-intel-core-i5-1335u-intel-iris-xe-graphics-16gb-ram-ssd-512gb-free-_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0195816_asus-vivobook-16-m3604ya-mb106-black_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2Ffa42c460-93b0-47b1-84dd-5da038a31c118ca3d25c-8067-4b3f-8d19-6f398c1740fe.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0194784_lenovo-ideapad-slim-3-82x80025rk-intel-core-i5-1335u-intel-iris-xe-graphics-16gb-ram-ssd-512gb-free-_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0195816_asus-vivobook-16-m3604ya-mb106-black_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fsite%2Ffa42c460-93b0-47b1-84dd-5da038a31c118ca3d25c-8067-4b3f-8d19-6f398c1740fe.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0194784_lenovo-ideapad-slim-3-82x80025rk-intel-core-i5-1335u-intel-iris-xe-graphics-16gb-ram-ssd-512gb-free-_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              <SwiperSlide>
              <Card 
                title={"Samsung Galaxy Fold 5 F946B/DS 5G 12/256GB "}
                price={2899}
                oldPrice={3099}
                monthPrice={111}
                image={"https://zoommer.ge/_next/image?url=https%3A%2F%2Fs3.zoommer.ge%2Fzoommer-images%2Fthumbs%2F0195816_asus-vivobook-16-m3604ya-mb106-black_550.jpeg&w=256&q=50"} />
              </SwiperSlide>
              
            </Productc>
            </div>
          </div>
        </div>
      </div> 
    </main>
  );
}

export default Main;